/**
 * Incremento del numero di versione per una duplicazione.
 *
 * Suggerisce il valore successivo, che l'utente resta libero di cambiare:
 * versione e lingua identificano il documento, quindi la scelta finale è sua.
 * Se il nome non termina con un numero, si aggiunge un suffisso invece di
 * indovinare uno schema che non c'è.
 */
export function nextVersion(version: string): string {
  const match = /^(.*?)(\d+)$/.exec(version);
  if (!match) return `${version}-2`;

  const [, prefix, digits] = match;
  const incremented = String(Number(digits) + 1).padStart(digits!.length, '0');
  return `${prefix}${incremented}`;
}
